// assets/remote-support-form.js dosyanızdaki TÜM kodu bununla değiştirin

document.addEventListener('DOMContentLoaded', function() {
    // Tüm Remote Support formlarını yakala
    document.querySelectorAll('[id^="remote-support-form-"]').forEach(remoteForm => {
        
        // Remote formun bulunduğu ana ürün detay alanını bulmaya çalış
        // Temanın DOM yapısına göre bu seçici değişebilir.
        const productContainer = remoteForm.closest('.product-details, .product-main, .shopify-section'); 
        
        // Ana ürünün Sepete Ekleme formunu bul (bu, ana ürün detay alanının içinde olmalı)
        // [data-product-form] ya da [data-form-type="product"] temalarda sıkça kullanılır.
        const productForm = productContainer ? productContainer.querySelector('form[action="/cart/add"]') : null;

        if (productForm) {
            // Ana formun submit olayını dinle (Add to Cart butonu tıklandığında tetiklenir)
            productForm.addEventListener('submit', function(e) {
                
                // 1. ZORUNLU ALAN KONTROLÜ
                if (!remoteForm.checkValidity()) {
                    e.preventDefault(); // Ana formun gönderilmesini ENGELLE
                    
                    remoteForm.reportValidity(); // Hatalı alanları göster
                    
                    // Kullanıcıyı formun başına kaydır
                    remoteForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    
                    // Form mesajını gizle/temizle
                    const messageElement = remoteForm.querySelector('[id^="form-message-"]');
                    if (messageElement) {
                         messageElement.style.display = 'none';
                    }
                    
                    return false; // İşlemi durdur
                }
                
                // --- KONTROL BAŞARILI: Verileri Ana Forma Kopyala ---
                
                // Remote form alanlarını ana forma kopyalama
                const remoteFormData = new FormData(remoteForm);
                
                remoteFormData.forEach((value, key) => {
                    // Sadece 'properties' ile başlayan alanları kopyalar
                    if (key.startsWith('properties[')) {
                        // Kopyalanan alanlar gizli input olarak ana forma eklenir
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = key;
                        input.value = value;
                        productForm.appendChild(input);
                    }
                });

                // Başarılı mesajını göster (isteğe bağlı)
                const messageElement = remoteForm.querySelector('[id^="form-message-"]');
                if (messageElement) {
                    messageElement.style.display = 'block';
                    messageElement.textContent = 'Form details added to cart properties...';
                }

                // e.preventDefault() çağrılmadığı için, ana form normal şekilde submit olmaya devam edecektir.
            });
        } else {
             console.warn('Ana ürün formu ([action="/cart/add"]) bulunamadı. Lütfen JS seçicilerini kontrol edin.');
        }
    });
});